import React from 'react';

const CustomerParcelPickupDrop = () => {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-4">Customer Parcel Pickup and Drop-Off Procedure for Xgo Life App</h1>
      <p className="mb-4">
        By following this procedure, customers can efficiently hail parcel pickup and drop-off services using the Xgo Life App, ensuring a smooth and reliable delivery experience.
      </p>

      <h2 className="text-2xl font-semibold mt-6">1. Account Setup</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Download the App:</strong> Install the Xgo Life App from the App Store or Google Play Store.</li>
        <li><strong>Create an Account:</strong> Sign up by providing your email address, phone number, and creating a password. Verify your account through the confirmation link sent to your email.</li>
      </ul>

      <h2 className="text-2xl font-semibold">2. Accessing the Parcel Service</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Open the App:</strong> Launch the Xgo Life App and log in to your account.</li>
        <li><strong>Select Parcel Service:</strong> Navigate to the parcel pickup and drop-off section from the main menu or home screen.</li>
      </ul>

      <h2 className="text-2xl font-semibold">3. Setting Pickup Location</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Enable Location Services:</strong> Allow the app to access your location for accurate pickup points.</li>
        <li><strong>Enter Pickup Address:</strong> Input your pickup address manually or select it from the map.</li>
      </ul>

      <h2 className="text-2xl font-semibold">4. Entering Drop-Off Location</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Specify Destination:</strong> Enter the address for where the parcel needs to be delivered.</li>
        <li><strong>Confirm Location:</strong> Ensure both pickup and drop-off locations are correct before proceeding.</li>
      </ul>

      <h2 className="text-2xl font-semibold">5. Parcel Details</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Provide Parcel Information:</strong> Enter details about the parcel, including weight, dimensions, and any special handling instructions.</li>
        <li><strong>Select Service Type:</strong> Choose the type of service required (e.g., standard, express, or same-day delivery).</li>
      </ul>

      <h2 className="text-2xl font-semibold">6. Requesting Pickup</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Review Summary:</strong> Check the details of your request, including pickup and drop-off locations, parcel information, and service type.</li>
        <li><strong>Request Pickup:</strong> Tap the "Request Pickup" button to schedule the service. The app will search for available drivers.</li>
      </ul>

      <h2 className="text-2xl font-semibold">7. Waiting for Driver Confirmation</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Driver Assignment:</strong> Once a driver is assigned, you will receive a notification with the driver’s details, including name, vehicle information, and estimated time of arrival (ETA).</li>
        <li><strong>Track Driver:</strong> You can track the driver’s location in real-time on the map within the app.</li>
      </ul>

      <h2 className="text-2xl font-semibold">8. During Pickup</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Prepare the Parcel:</strong> Ensure your parcel is ready for pickup at the designated location.</li>
        <li><strong>Communicate with Driver:</strong> Use the in-app messaging or calling feature if needed to coordinate the pickup.</li>
      </ul>

      <h2 className="text-2xl font-semibold">9. Completing the Pickup</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Driver Arrival:</strong> When the driver arrives, confirm their identity using the app. Ensure they handle your parcel carefully.</li>
        <li><strong>Hand Over the Parcel:</strong> Give the parcel to the driver and confirm the pickup in the app.</li>
      </ul>

      <h2 className="text-2xl font-semibold">10. Payment Process</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Automatic Payment:</strong> Payment will be processed automatically through your selected payment method in the app.</li>
        <li><strong>Review Fare:</strong> Check the fare breakdown, including any surcharges or discounts applied.</li>
      </ul>

      <h2 className="text-2xl font-semibold">11. Tracking the Parcel</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Track Delivery Status:</strong> Use the app to monitor the status of your parcel during transit. You will receive updates on its progress.</li>
      </ul>

      <h2 className="text-2xl font-semibold">12. Delivery Confirmation</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Arrival Notification:</strong> You’ll receive a notification when your parcel has been delivered.</li>
        <li><strong>Confirmation of Delivery:</strong> The driver may require a signature or confirmation from the recipient.</li>
      </ul>

      <h2 className="text-2xl font-semibold">13. Rating and Feedback</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Rate Your Experience:</strong> After the delivery, rate your driver and provide feedback on your experience.</li>
        <li><strong>Report Issues:</strong> If there are any issues with the pickup or delivery, report them through the app’s support feature.</li>
      </ul>

      <h2 className="text-2xl font-semibold">14. Customer Support</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Access Help Center:</strong> If you have questions or need assistance, visit the Help Center in the app for FAQs or contact customer support directly.</li>
      </ul>
    </div>
  );
};

export default CustomerParcelPickupDrop;